export default "__VITE_ASSET__C54lAXAh__"